module.exports = __webpack_public_path__ + "img/ys-sixteen-grid.ecdfab97.png";